import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WebCamModule } from 'ack-angular-webcam';
import { PlatformExaminationPage } from './platform-examination';


@NgModule({
  declarations: [
    PlatformExaminationPage,
  ],
  imports: [
    IonicPageModule.forChild(PlatformExaminationPage),
    WebCamModule,
  ],
  exports:[
    PlatformExaminationPage
  ]
})
export class PlatformExaminationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/platform-examination/platform-examination.module.ts